import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import toastr from "toastr";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// import GridContainer from "../../components/Grid/GridContainer"
// import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "@material-ui/core/Button";
// import Card from "../../components/Card/card.jsx"
// import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CommonModel from "../Common/Model/CommonModel";
import IconButton from "@material-ui/core/IconButton";

import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { resetPassword } from "../../actions/admin_action";
// import { FaHandHoldingHeart } from "react-icons/fa";

toastr.options = {
  closeButton: true,
};

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPass: "",
      confirmPass: "",
      oldPass: "",
      showNewPassword: false,
      showOldPassword: false,
      showConfPassword: false,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleClickShowNewPassword = () => {
    this.setState({
      showNewPassword: !this.state.showNewPassword,
    });
  };
  handleClickShowOldPassword = () => {
    this.setState({
      showOldPassword: !this.state.showOldPassword,
    });
  };

  handleClickShowConfPassword = () => {
    this.setState({
      showConfPassword: !this.state.showConfPassword,
    });
  };

  resetPassword = () => {
    const { newPass, confirmPass, oldPass } = this.state;
    if (!oldPass) {
      toastr.error("Please enter Old password");
    } else if (!newPass) {
      toastr.error("Please enter New password");
    } else if (!confirmPass) {
      toastr.error("Please confirm your password");
    } else if (newPass !== confirmPass) {
      toastr.error("Passwords should match");
    } else {
      let url_string = window.location.href;
      let url = new URL(url_string);
      let id = url_string.split("/")[6];
      //console.log(id);
      let obj = {
        oldPassword: oldPass,
        newPassword: newPass,
        //password: confirmPass,
        _id: id,
      };
      this.props.resetPassword(obj);
    }
  };

  render() {
    const { classes } = this.props;
    const { show, handleClose } = this.props;
    const {
      showNewPassword,
      showConfPassword,
      showOldPassword,
      newPass,
      confirmPass,
      oldPass,
    } = this.state;

    console.log(")()()", classes.container);

    return (
      <div>
        {this.state.error && this.showError(this.state.error)}
        <Dialog
          justify="center"
          maxWidth={"md"}
          open={show}
          onClose={handleClose}
        >
          <DialogTitle id="form-dialog-title">
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter}`}
              color="primary"
            >
              <h4 className={classes.cardTitle}>Reset Password</h4>
            </CardHeader>
          </DialogTitle>
          <DialogContent style={{ width: "600px", maxWidth: "100%" }}>
            {/* <GridItem xs={12} sm={6} md={4}>
            <Card login className={classes[this.state.cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="primary"
              >
                <h4 className={classes.cardTitle}>Reset Password</h4>
              </CardHeader>
              <CardBody> */}
            <FormControl fullWidth>
              <InputLabel htmlFor="adornment-password">Old password</InputLabel>
              <Input
                id="adornment-password"
                type={showOldPassword ? "text" : "password"}
                fullWidth
                value={oldPass}
                onChange={(e) => {
                  this.setState({
                    oldPass: e.target.value,
                  });
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowOldPassword}
                    >
                      {showOldPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: "15px" }}>
              <InputLabel htmlFor="adornment-password">New password</InputLabel>
              <Input
                id="adornment-password"
                type={showNewPassword ? "text" : "password"}
                fullWidth
                value={newPass}
                onChange={(e) => {
                  this.setState({
                    newPass: e.target.value,
                  });
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowNewPassword}
                    >
                      {showNewPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: "15px" }}>
              <InputLabel htmlFor="adornment-password">
                Confirm password
              </InputLabel>
              <Input
                id="adornment-password"
                type={showConfPassword ? "text" : "password"}
                fullWidth
                value={confirmPass}
                onChange={(e) => {
                  this.setState({
                    confirmPass: e.target.value,
                  });
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowConfPassword}
                    >
                      {showConfPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {/* </CardBody> */}
            <div
              style={{
                textAlign: "center",
                margin: "10px",
                marginTop: "30px",
              }}
            >
              <DialogActions style={{ textAlign: "center", display: "block" }}>
                <Button
                  color="primary"
                  onClick={handleClose}
                  className="canbutton"
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.resetPassword}
                  //style={{ width: "50%" }}
                >
                  Submit
                </Button>
              </DialogActions>
            </div>
            {/* </Card> */}
            {/* </GridItem> */}
          </DialogContent>
        </Dialog>

        <CommonModel show={this.state.show} path="/" msg={this.state.msg} />
      </div>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (obj) => dispatch(resetPassword(obj)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(loginPageStyle)(ResetPassword));
